import {
  ChangeDetectionStrategy,
  Component,
  input,
  InputSignal,
} from '@angular/core';
import { SpinnerSize } from '@lyceo/shared/util-models';
import { ContentComponent } from '../content/content.component';
import { SpinnerComponent } from '../spinner/spinner.component';

@Component({
  selector: 'lyceo-loader',
  imports: [ContentComponent, SpinnerComponent],
  templateUrl: './loader.component.html',
  styleUrl: './loader.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoaderComponent {
  public readonly imageSrc: InputSignal<string> = input.required();

  protected readonly SpinnerSize: typeof SpinnerSize = SpinnerSize;
}
